<template>
  <div class="m-common__review__item" id="base-review-item">
    <a :href="itemDetailUrl">
      <span class="review__item__thumb">
        <img :src="itemImageUrl" alt="">
      </span>
      <span class="review__item__title">{{ itemName }}</span>
    </a>
    <slot />
  </div>
</template>

<script>
import urls from '@/mixins/urls'
export default {
  name: 'BaseReviewItem',
  mixins: [ urls ],
  props: {
    skuCode: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      default: ''
    }
  },
  computed: {
    itemDetailUrl () {
      return this.getItemDetailUrl(this.skuCode)
    },
    itemImageUrl () {
      return this.getItemImageUrl(this.skuCode)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BaseReviewItem.vue